import { render, staticRenderFns } from "./Edu.vue?vue&type=template&id=0c42e452&scoped=true&"
import script from "./Edu.vue?vue&type=script&lang=js&"
export * from "./Edu.vue?vue&type=script&lang=js&"
import style0 from "./Edu.vue?vue&type=style&index=0&id=0c42e452&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c42e452",
  null
  
)

export default component.exports